import {
    TRANSACTION_FETCH_REQUEST,
    TRANSACTION_FETCH_SUCCESS,
    TRANSACTION_FETCH_FAIL,
  } from "../constants/transactionConstants";
  
  const initialState = {
    transactions: [],
    loading: false,
    error: null,
  };

  export const transactionReducer = (state = initialState, action) => {
    switch (action.type) {
      case TRANSACTION_FETCH_REQUEST:
        return { loading: true, transactions: [] };
      case TRANSACTION_FETCH_SUCCESS:
        return { loading: false, transactions: action.payload };
      case TRANSACTION_FETCH_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };